import { Entity } from 'types'

const getEntityName = (profile?: Entity) => {
  return profile?.name || 'Hi there!'
}

export default getEntityName
